import React from 'react';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

export default function Header({ data }) {
  return (
    <nav className="fixed z-100">
      <DesktopHeader data={data} />
      <MobileHeader data={data} />
    </nav>
  );
}
